import { api } from 'api'
import { useMutation } from '@tanstack/react-query'
import { toaster } from 'uikit/Toaster'
import { DATE_FORMAT } from 'shared/utils/dateFormatting'
import moment from 'moment/moment'

const dateFormat = 'YYYY-MM-DD'

export const useSendPaymentsRegistry = () => {
  return useMutation({
    mutationFn: ({ date }: any) => {
      const momentDate = moment(date, DATE_FORMAT)

      return api.payments.sendSettingsRegistry({
        from: date ? momentDate.format(dateFormat) : undefined,
        to: date ? momentDate.add(1, 'd').format(dateFormat) : undefined,
      })
    },
    onSuccess: () => {
      toaster.create({
        type: 'success',
        title: 'Запрос на формирование отчета отправлен успешно',
      })
    },
    onError: (err) => {
      toaster.create({
        type: 'error',
        title: 'Произошла ошибка при отправке реестров',
        description: err.message,
      })
    },
  })
}
